import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";
import type { ThunkDispatch } from "redux-thunk";
import type { AnyAction } from "redux";
import type { RootState } from "store";
import { logoutUser } from "slices/thunks";
import logoSm from "../../assets/images/logo-sm.png";
import WebCartIcon from "./WebCartIcon";
import ServicesDropdown from "./ServicesDropdown";
import ReportDropdown from "./ReportDropdown";

// Select authenticated flag from Login slice
const selectLoginState = (state: any) => state.Login;
const loginSelector = createSelector(selectLoginState, (login: any) => ({
  isAuthenticated: login.isAuthenticated,
}));

const DashboardHeader: React.FC = () => {
  const dispatch: ThunkDispatch<RootState, any, AnyAction> = useDispatch();
  const navigate = useNavigate();
  const { isAuthenticated } = useSelector(loginSelector);

  const handleLogout = () => {
    dispatch(logoutUser());
    navigate("/login");
  };

  return (
    <header className="dashboard-header">
      <div className="header-content">
        <div className="logo-section">
          <img src={logoSm} alt="Amanat Logo" height="45" />
          <div className="logo-text">
            <h4>Amanat</h4>
            <p>Enabling Financial Well-being for All</p>
          </div>
        </div>
        <nav className="header-nav">
          <a href="https://amanatfintech.com/" target="_blank" rel="noopener noreferrer">
            Home
          </a>
          <ServicesDropdown />
          <a href="https://amanatfintech.com/about/" target="_blank" rel="noopener noreferrer">
            About
          </a>
          <a href="https://amanatfintech.com/about/#team" target="_blank" rel="noopener noreferrer">
            Team
          </a>
          <a href="https://amanatfintech.com/impact/" target="_blank" rel="noopener noreferrer">
            Impact
          </a>
          {isAuthenticated && <ReportDropdown />}
          <a href="https://amanatfintech.com/#contact" target="_blank" rel="noopener noreferrer">
            Contact
          </a>
          <WebCartIcon />
          {isAuthenticated ? (
            <Button 
              className="contact-btn" 
              color="warning"
              onClick={handleLogout}
            >
              Logout
            </Button>
          ) : (
            <Link to="/login">
              <Button className="contact-btn" color="warning">
                Login
              </Button>
            </Link>
          )}
        </nav>
      </div>
    </header>
  );
};

export default DashboardHeader;

